/**
 * API Keys Settings Page
 */

import { Card, Heading, Stack, Text } from '@cortex/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/api-keys')({
  component: ApiKeysSettingsPage,
});

function ApiKeysSettingsPage() {
  return (
    <Stack>
      <Heading level={1} className="mb-6 text-2xl font-semibold">
        API Keys
      </Heading>

      <Card className="max-w-2xl p-6">
        <Text color="secondary">
          Manage your API keys for programmatic access to Cortex.
        </Text>
      </Card>
    </Stack>
  );
}
